module.exports = __webpack_public_path__ + "img/DateTimeRange.34df33c5.svg";